import api from '@/api/log'
import { mergeUserContext } from '@/store/helpers'

const state = {
  logs: []
}

const getters = {
  getLogs: state => state.logs
}

const actions = {
  async addViewPersonLog ({ commit, state }, payload) {
    const response = await api.addViewPersonLog(payload)
    console.log(response.body)
  },
  async addViewNoteLog ({ commit, state }, payload) {
    const response = await api.addViewNoteLog(payload)
    console.log(response.body)
  },
  async addViewAssessmentLog ({ commit, state }, payload) {
    const response = await api.addViewAssessmentLog(payload)
    console.log(response.body)
  },
  async getLogs ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    var response = await api.getLogs(payload)
    commit('setLogs', response.body)
    return response.body
  },
  async clearTestData ({ commit, state }, payload) {
    var response = await api.clearTestData(payload)
    return response.body
  }
}

const mutations = {
  setLogs (state, records) {
    state.logs = records
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/log.js